<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4.00003 15.25C3.17161 15.25 2.48059 14.5703 2.65786 13.7611C3.1121 11.6873 4.5493 10 7.00003 10C9.45073 10 10.888 11.6873 11.3422 13.7611C11.5195 14.5703 10.8285 15.25 10 15.25H4.00003Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.5 14.5H16C16.8284 14.5 17.5218 13.8197 17.3394 13.0116C17.0166 11.5817 16.173 10.2789 14.5 10" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 10C8.44975 10 9.625 8.82475 9.625 7.375C9.625 5.92525 8.44975 4.75 7 4.75C5.55025 4.75 4.375 5.92525 4.375 7.375C4.375 8.82475 5.55025 10 7 10Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.3125 10C15.4516 10 16.375 9.07659 16.375 7.9375C16.375 6.79841 15.4516 5.875 14.3125 5.875C13.1734 5.875 12.25 6.79841 12.25 7.9375C12.25 9.07659 13.1734 10 14.3125 10Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PartnershipAdsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>